import { createReducer, on } from '@ngrx/store';
import {
  getAppInitializationFailure,
  getAppInitializationRequest,
  getAppInitializationSuccess,
} from '../actions';

export interface AppInitializationState {
  initialized: boolean;
  initializing: boolean;
  failed: boolean;
}

export const initialState: AppInitializationState = {
  initialized: false,
  initializing: false,
  failed: false,
};

export const appInitializationReducer = createReducer(
  initialState,
  on(getAppInitializationRequest, (state) => ({
    ...state,
    initializing: state.initialized ? false : true,
  })),
  on(getAppInitializationSuccess, (state) => ({
    ...state,
    initialized: true,
    initializing: false,
  })),
  on(getAppInitializationFailure, (state) => ({
    ...state,
    failed: state.initialized ? false : true,
    initializing: false,
  }))
);
